<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Merchant</h3>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <button class="btn mb-1 btn-primary btn-lg btn-block" v-on:click="scan()">Scan Order</button>
                <button class="btn mb-1 btn-primary btn-lg btn-block" v-on:click="logout()">Logout</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'merchantDashboard',
  data: function () {
    return {
      code: ''
    }
  },
  methods: {
    scan: function () {
      $.showLoading()
      var that = this

      // eslint-disable-next-line
      cordova.plugins.barcodeScanner.scan(
        function (result) {
          $.hideLoading()
          window.localStorage.setItem('code', result.text)
          that.$router.push('/merchant/checkout')
        },
        function (error) {
          alert('Scanning failed: ' + error)
        }, {
          preferFrontCamera: true,
          showFlipCameraButton: true
        }
      )
    },
    logout: function () {
      localStorage.clear()
      this.$router.push('/login')
    }
  }
}
</script>
